import TncLicenseAgreement from './TncLicenseAgreement/TncLicenseAgreement';

import JDFLogo from '../../assets/svg/jdf_logo.svg';
import AlertWidget from '../../lib/Alert/Alert';
import {postAPICall} from '../../services/apiCallsHandler';
import {NRStatus} from '../../utils/constant';
import Smartlook from '../../utils/smartlook';
import {
  downloadPDF,
  OpenWebURL,
  sendCustomDataNR,
  sendScreenViewNR,
} from '../../utils/util';
import AccountConfiguration from '../accountConfiguration/accountConfiguration';

import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Link,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './termsAndConditions.css';

const TermsAndConditions = (props) => {
  const [tncAccepted, setTncAccepted] = React.useState(true);
  const [tncLoading, setTncLoading] = React.useState(false);
  const [tncError, setTncError] = React.useState(false);
  const [rendarAccountSetupPage, setRendarAccountSetupPage] =
    React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const {enqueueToast} = useToastProvider();
  const {t} = useTranslation();
  const docType = 'TNC_DOC';
  const NR_ACTION = 'TermsAndConditions';

  React.useEffect(() => {
    sendScreenViewNR('termsAndConditions');
    Smartlook.navigation('termsAndConditions');
  }, []);

  const handleTncSubmit = async () => {
    setTncLoading(true);
    await postAPICall(
      'tncAccepted',
      {
        customerId: props.custId,
        countryCode: localStorage.getItem('countryCode'),
      },
      {
        isCallBack: false,
        errorTag: 'TNC_ACCEPTING',
        redirectToOops: false,
      }
    ).then(async (res) => {
      setTncLoading(false);
      if (res?.status === 200) {
        sendCustomDataNR(
          NR_ACTION,
          sessionStorage.getItem('trace-id'),
          localStorage.getItem('countryCode'),
          null,
          NRStatus.tnc,
          props.custId
        );
        setRendarAccountSetupPage(true);
      } else if (res.status === 500) {
        setTncError(true);
        setTimeout(() => {
          setTncError(false);
        }, 2000);
      }
    });
  };

  React.useEffect(() => {
    window.scrollTo(0, 120);
  }, [tncAccepted]);
  return (
    <div className={'termsAndConditionsWrapper'}>
      <header id="tncHeader" data-testid="tncHeader">
        <div className="jdf-logo">
          <img src={JDFLogo} alt="JDF Logo" />
        </div>
      </header>
      {tncError && (
        <AlertWidget
          type="error"
          title=""
          content="TNC_ERROR"
          isClosable={true}
        />
      )}

      {rendarAccountSetupPage ? (
        <AccountConfiguration redirectHome={() => props.isRedirectedToHome()} />
      ) : (
        <div className={'termsAndConditionsContent'}>
          <div className={'termsAndConditionsTitle'}>
            {t('ORGANIZATION_TERMS_&_CONDITIONS')}
          </div>
          <div className="termsAndConditionsBody" id="termsAndConditionsBody">
            <TncLicenseAgreement />
          </div>
          <div className={'termsAndConditionsLinks'}>
            <Button
              id="downloadTnc"
              variant="secondary"
              disabled={isDownloading}
              onClick={() =>
                downloadPDF(docType, enqueueToast, setIsDownloading, t)
              }
            >
              {t('DOWNLOAD')}
            </Button>
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                OpenWebURL('weburl', t('Eula_FifthPointLink1'), 'sameTab');
              }}
              id="privacyAndDataLink"
            >
              {t('PRIVACY_DATA_AGREEMENT')}
            </Link>
          </div>
          <div className={'termsAndConditionsAction'}>
            <FormControlLabel
              control={
                <Checkbox
                  id="tncChekbox"
                  data-testid="tncChekbox"
                  name="tncChekbox"
                  checked={tncAccepted}
                  onChange={(e) => setTncAccepted(e.target.checked)}
                />
              }
              label={t('TNC_ACCEPTING_CHECKBOX_TEXT')}
            />
          </div>
          <div className={'termsAndConditionsNext'}>
            <Button
              id="tncNext"
              data-testid="tncNext"
              variant="primary"
              onClick={() => handleTncSubmit()}
              disabled={!tncAccepted || tncLoading}
              startIcon={
                tncLoading && (
                  <CircularProgress size="small" style={{color: '#000'}} />
                )
              }
            >
              {t('NEXT')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
export default TermsAndConditions;
